// 土壤监测-历史数据
<template>
  <el-card>
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-input :value="deviceNumber" disabled></el-input>
      </el-form-item>
      <el-form-item prop="dateRange">
        <el-date-picker :clearable="false" v-model="searchInfo.dateRange" type="daterange" range-separator="-"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item label="数据名称">
        <el-select placeholder="请选择" v-model="echartSelect" @change="changeEchart">
          <div v-for="(item, index) in typeList" :key="index">
            <el-option :value="item.value" :label="item.label" v-if="getFind(item.type)"></el-option>
          </div>
        </el-select>
      </el-form-item>
    </el-form>
    <div ref="echart" class="echart mb20"></div>
    <el-table class="global-table" v-loading="loading" :data="dataList">
      <el-table-column label="采集时间" prop="collectTime" min-width="160px"></el-table-column>
      <el-table-column label="温度(℃)" prop="temperature" min-width="120px" v-if="getFind('temperature')">
        <template v-slot="{ row }">
          {{ row.temperature || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="湿度(%)" prop="humidity" min-width="120px" v-if="getFind('humidity')">
        <template v-slot="{ row }">
          {{ row.humidity || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="pH" prop="ph" min-width="120px" v-if="getFind('ph')">
        <template v-slot="{ row }">
          {{ row.ph || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="EC(mS/cm)" prop="conductivity" min-width="120px" v-if="getFind('conductivity')">
        <template v-slot="{ row }">
          {{ row.conductivity || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="氮(mg/kg)" prop="nitrogen" min-width="120px" v-if="getFind('nitrogen')">
        <template v-slot="{ row }">
          {{ row.nitrogen || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="磷(mg/kg)" prop="phosphorus" min-width="120px" v-if="getFind('phosphorus')">
        <template v-slot="{ row }">
          {{ row.phosphorus || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="钾(mg/kg)" prop="potassium" min-width="120px" v-if="getFind('potassium')">
        <template v-slot="{ row }">
          {{ row.potassium || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="ORP(mV)" prop="redox" min-width="120px" v-if="getFind('redox')">
        <template v-slot="{ row }">
          {{ row.redox || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="剩余电量(%)" prop="quanity" min-width="120px">
        <template v-slot="{ row }">
          {{ row.quanity || '--' }}
        </template>
      </el-table-column>
    </el-table>
    <global-pagination @size-change="getData" @current-change="getData" :current-page.sync="page" :page-size.sync="size"
      :total="total">
    </global-pagination>
  </el-card>
</template>

<script>
// import * as echarts from 'echarts'
export default {
  name: 'SoilHistory',
  data () {
    return {
      searchInfo: {
        dateRange: []
      },

      selectTime: 0,
      pickerOptions: {
        // 选中日期后会执行的回调
        onPick: (date) => {
          this.selectTime = date.minDate.getTime()
          if (date.maxDate) {
            this.selectTime = 0
          }
        },
        disabledDate: (time) => {
          if (this.selectTime !== 0) {
            const dayTime = 29 * 24 * 3600 * 1000
            const minTime = this.selectTime - dayTime
            const maxTime = this.selectTime + dayTime
            return (time.getTime() < minTime || time.getTime() > maxTime)
          }
        }
      },

      loading: false,
      dataList: [],
      chartList: [],
      page: 1,
      size: 10,
      total: 0,
      echartSelect: '0',
      echartData: {
        ph: [],
        humidity: [],
        conductivity: [],
        temperature: [],
        deviceNumber: '',
        collectTime: [],
        nitrogen: [],
        phosphorus: [],
        potassium: [],
        redox: []
      },
      typeList: [],
      finds: []
    }
  },
  computed: {
    deviceNumber () {
      return this.$route.params.deviceNumber
    }
  },
  created () {
    this._echart = null
    this.initTime()
    this.getData()
    this.getChartList()
  },

  mounted () {
    window.addEventListener('resize', this.resize)
  },

  destroyed () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    initTime () {
      const val = this.$dayjs().format('YYYY-MM-DD')
      const vals = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      console.log(vals)
      this.searchInfo.dateRange = [vals, val]
    },

    getData () {
      if (this.searchInfo.dateRange && this.searchInfo.dateRange[0]) {
        this.loading = true
        this.$axios.get(this.$apis.irrigation.selectSoilDataByPage, {
          deviceNumber: this.deviceNumber,
          startTime: this.searchInfo.dateRange[0],
          endTime: this.searchInfo.dateRange[1],
          page: this.page,
          size: this.size
        }).then((res) => {
          this.total = res.soil.total || 0
          this.dataList = res.soil.list || []
          this.finds = res.finds
        // this.getEchartsData()
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$message.error('请选择查询日期范围')
      }
    },

    onSearch () {
      this.page = 1
      this.getData()
      this.getChartList()
    },

    // 图表总数据
    getChartList () {
      if (this.searchInfo.dateRange && this.searchInfo.dateRange[0]) {
        this.$axios.get(this.$apis.irrigation.selectSoilDataByPage, {
          deviceNumber: this.deviceNumber,
          startTime: this.searchInfo.dateRange[0],
          endTime: this.searchInfo.dateRange[1]
        }).then((res) => {
          this.chartList = res.soil.list || []
          this.getEchartsData()
        })
      } else {
        this.$message.error('请选择查询日期范围')
      }
    },

    // 图表数据
    getEchartsData () {
      this.echartData = {
        ph: [],
        humidity: [],
        conductivity: [],
        temperature: [],
        deviceNumber: '',
        collectTime: [],
        nitrogen: [],
        phosphorus: [],
        potassium: [],
        redox: []
      }
      if (this.chartList.length > 0) {
        this.chartList.forEach(item => {
          this.echartData.deviceNumber = item.deviceNumber
          this.echartData.temperature.push(item.temperature)
          this.echartData.humidity.push(item.humidity)
          this.echartData.ph.push(item.ph)
          this.echartData.conductivity.push(item.conductivity)
          this.echartData.nitrogen.push(item.nitrogen)
          this.echartData.phosphorus.push(item.phosphorus)
          this.echartData.potassium.push(item.potassium)
          this.echartData.redox.push(item.redox)
          this.echartData.collectTime.push(item.collectTime)
        })
      }
      this.typeList = [
        {
          legendData: '土壤温度',
          color: 'rgba(255, 193, 23, ',
          data: this.echartData.temperature,
          unit: '℃',
          value: '0',
          label: '土壤温度曲线图',
          type: 'temperature'
        },
        {
          legendData: '土壤湿度',
          color: 'rgba(44, 142, 255, ',
          data: this.echartData.humidity,
          unit: '℃',
          value: '1',
          label: '土壤湿度曲线图',
          type: 'humidity'
        },
        {
          legendData: 'pH',
          color: 'rgba(18, 194, 194, ',
          data: this.echartData.ph,
          unit: '',
          value: '2',
          label: 'pH值曲线图',
          type: 'ph'
        },
        {
          legendData: 'EC',
          color: 'rgba(47, 194, 90, ',
          data: this.echartData.conductivity,
          unit: 'mS/cm',
          value: '3',
          label: 'EC值曲线图',
          type: 'conductivity'
        },
        {
          legendData: '氮',
          color: 'rgba(255, 193, 23, ',
          data: this.echartData.nitrogen,
          unit: 'mg/kg',
          value: '4',
          label: '氮含量曲线图',
          type: 'nitrogen'
        },
        {
          legendData: '磷',
          color: 'rgba(44, 142, 255, ',
          data: this.echartData.phosphorus,
          unit: 'mg/kg',
          value: '5',
          label: '磷含量曲线图',
          type: 'phosphorus'
        },
        {
          legendData: '钾',
          color: 'rgba(109, 212, 0, ',
          data: this.echartData.potassium,
          unit: 'mg/kg',
          value: '6',
          label: '钾含量曲线图',
          type: 'potassium'
        },
        {
          legendData: 'ORP',
          color: 'rgba(47, 194, 90, ',
          data: this.echartData.redox,
          unit: 'mV',
          value: '7',
          label: 'ORP含量曲线图',
          type: 'redox'
        }
      ]
      this.draw(Number(this.echartSelect))
    },

    // 折线图
    draw (type) {
      this.$nextTick(() => {
        const series = []
        const params = this.typeList[type]
        console.log(params)
        series.push({
          name: params.legendData,
          type: 'line',
          symbolSize: 10,
          yAxisIndex: 0,
          smooth: true,
          lineStyle: {
            width: 4,
            shadowBlur: 0,
            shadowColor: `${params.color}0.2)`,
            shadowOffsetY: 20
          },
          itemStyle: {
            normal: {
              borderWidth: 4,
              borderColor: `${params.color}1)`
            }
          },
          data: params.data
        })
        this.echart = echarts.init(this.$refs.echart)
        const option = {
          tooltip: {
            trigger: 'axis',
            confine: true,
            textStyle: {
              fontSize: 12
            }
          },
          grid: {
            top: 50,
            left: 30,
            right: 10,
            bottom: 10,
            containLabel: true
          },
          backgroundColor: 'transparent',
          legend: {
            icon: 'rect',
            itemWidth: 12,
            itemHeight: 1,
            orient: 'horizontal',
            align: 'left',
            top: 0,
            left: 0,
            itemGap: 30,
            textStyle: {
              fontSize: 12,
              fontWeight: 400,
              color: '#8c8c8c',
              lineHeight: 14
            }
          },
          color: `${params.color}1)`,
          xAxis: {
            type: 'category',
            axisTick: {
              alignWithLabel: {
                boundaryGap: true
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.45)'
              }
            },
            axisLabel: {
              show: true,
              margin: 15,
              textStyle: {
                color: 'rgba(0, 0, 0, 0.45)'
              }
            },
            data: this.echartData.collectTime
          },
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: `{value}${params.unit}`
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.45)'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.15)'
              }
            }
          }],
          series: series
        }
        this.echart.setOption(option, true)
      })
    },

    resize () {
      if (this.echart) {
        this.echart.resize()
      }
    },

    changeEchart (type) {
      this.draw(Number(type))
    },

    // 判断展示字段
    getFind (str) {
      return this.finds.find((item) => item === str)
    }
  }

}
</script>

<style scoped lang="scss">
.echart {
  width: 100%;
  height: 500px;
}
</style>
